import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-map-01',
  imports: [],
  templateUrl: './map-01.html',
  styleUrl: './map-01.scss',
})
export class Map01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
